<template>

  <el-col align="left">
    <popup
      button-style="primary"
      heading="Add Sites"
      button-text="Sites"
      :center-button="true"
      :disable-button="!isManager('project|maintenance|management')"
      button-icon="fa fa-broadcast-tower"
      @save="onSave"
      @close="onClose">

      <el-row :gutter="8">

        <el-col :sm="24" :md="12" :lg="12">
          <el-col :span="20">
            <select-site v-model="site" full-object />
          </el-col>
          <el-col :span="4">
            <el-button
              v-if="site"
              style="margin-top: 67px;"
              type="success"
              size="large"
              @click="unSelectedSites">
              &gt;&gt;
            </el-button>
          </el-col>

<!--
            <data-table
                url="/sites"
                title="All Sites"
                sort-field="siteName"
                :fields="['__checkbox','siteId', 'status','siteName']"
                :checkedCallback="unSelectedSites" />
-->
        </el-col>

        <el-col :sm="24" :md="12" :lg="12">

            <el-table stripe border :data="selected" max-height="528" @selection-change="selectedSitesCheck">
              <el-table-column type="selection" width="52" />
              <el-table-column prop="siteId" label="Site ID" width="174" />
              <el-table-column prop="status" label="Status" />
              <el-table-column prop="siteName" label="Site Name" width="528" />
            </el-table>

        </el-col>

      </el-row>
    </popup>
  </el-col>

</template>



<script>

  import ArrayMixins from '@/mixins/ArrayMixins'
  import PostMixins from '@/mixins/PostMixins'

  export default {

    mixins: [ArrayMixins, PostMixins],

    props: {

      orgId: {
        type: Number,
        required: true
      },

      category: {
        type: String,
        default: 'Org. '
      }

    },


    methods: {

        onSave () {
          let data = {org_id: this.orgId, sites: this.clone(this.selected)}
          this.selected = []

          this.saveForm(this, '/org/sites', null, data, 'Sites for ' + this.category, null, null, true, 'orgSitesTable')
        },

        onClose () {
        },

        unSelectedSites () {
/*
            if (checked) {
              this.selected.push({id: row.id, status: row.status, siteId: row.siteId, siteName: row.siteName})
            } else {
              this.arrayRemoveById(this.selected, 'id', row.id)
            }
*/
        let row = this.site

        this.selected.push({site_id: row.id, organisation_id: this.orgId, status: row.status, siteId: row.siteId, siteName: row.siteName, updated_by: this.userName()})
        this.site = null

        },

        selectedSitesCheck (sel) {
          if (this.isArray(sel) && sel.length > 0) {
            for (let i = 0 ; i < sel.length ; i++ ) {
              this.arrayRemoveById(this.selected, 'id', sel[i].id)
            }
          }
        }

    },


    watch: {
           orgId: function (changed) {
           }

    },


data() {

       return {
              site: null,
              selected: []
              }

    }

  }

</script>
